import { minorUnitsToAmount } from "@redotech/money/currencies";
import { RateLandedCost } from "@redotech/redo-fulfillment-customs-common/rate-landed-cost";

export type LcgInfo =
  | { showLandedCost: false }
  | {
      showLandedCost: true;
      totalLandedCost: number;
      duties: number;
      taxes: number;
      fees: number;
      currency: string;
    };

/**
 * Rate landed costs are stored in currency-scaled minor units; every call
 * site works in major units. Convert in one place so the two can't drift.
 */
export const getLcgInfo = (
  option: { landedCost?: RateLandedCost | null } | string | null | undefined,
): LcgInfo => {
  if (
    option &&
    typeof option === "object" &&
    "landedCost" in option &&
    option.landedCost
  ) {
    const { currency } = option.landedCost;
    const duties = minorUnitsToAmount(option.landedCost.duties, currency);
    const taxes = minorUnitsToAmount(option.landedCost.taxes, currency);
    const fees = minorUnitsToAmount(option.landedCost.fees, currency);
    return {
      showLandedCost: true,
      totalLandedCost: duties + taxes + fees,
      duties,
      taxes,
      fees,
      currency,
    };
  }
  return { showLandedCost: false };
};

export const landedCostMajorUnits = (lcgInfo: LcgInfo | undefined): number =>
  lcgInfo?.showLandedCost ? lcgInfo.totalLandedCost : 0;
